export class PoQtyDReqDto {
    
    month: number;
    year: number;
    unitId: string;
    reportType: string;
}